import { Box, Breadcrumbs, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPageHeaderContainer = styled(Box)(() => ({
	background: 'linear-gradient(180deg, #263052 0%, #4558A4 100%)',
	color: '#ffffff',
	padding: '32px',
	minHeight: '120px',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
}));

export const BreadcrumbsContainer = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	padding: '16px 32px',
	borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
	fontSize: '0.875rem',
	'& .MuiBreadcrumbs-separator': {
		color: theme.palette.text.secondary,
		margin: '0 8px',
	},
	'& .MuiBreadcrumbs-li': {
		display: 'flex',
		alignItems: 'center',
	},
}));

export const StyledBreadcrumbText = styled(Typography)(({ theme }) => ({
	fontSize: '0.875rem',
	fontWeight: 500,
	color: theme.palette.primary.main,
}));

export const StyledBreadcrumbLink = styled(Link)(({ theme }) => ({
	fontSize: '0.875rem',
	fontWeight: 400,
	cursor: 'pointer',
	textDecoration: 'none',
	color: theme.palette.text.secondary,
	transition: 'color 0.2s ease-in-out',
	'&:hover': {
		color: theme.palette.primary.main,
		textDecoration: 'none',
	},
}));
